
export default class Simulator {
  constructor(element) {
    this.element = element;
  }

  mount() {
    const root = this.element.shadowRoot;
    const el = root.querySelector('.fws-microsimu');

    if (el) {
      this.applyStyles(root);
      return;
    }

    const observer = new MutationObserver(() => {
      if (root.querySelector('.fws-microsimu')) {
        observer.disconnect();
        clearTimeout(timeoutId);
        this.applyStyles(root);
      }
    });

    observer.observe(root, { childList: true, subtree: true });

    const timeoutId = setTimeout(() => {
      observer.disconnect();
      console.warn('fws-microsimu etais pas charge dans 5s');
    }, 5000);
  }

  applyStyles(root) {
    root.querySelector('.fws-microsimu').style.marginTop = '20px';
    root.querySelector('.fws-microsimu').style.minWidth = '0px';

    root.querySelector('.fws-microsimu__number').style.color = '#eb9125';
    root.querySelector('.fws-microsimu__number').style.fontSize = '1em';
    root.querySelector('.fws-microsimu__number').style.fontWeight = 'bold';

    root.querySelector('.fws-microsimu__first').style.border = 'solid 1px #f9d1a2';
    root.querySelector('.fws-microsimu__first').style.width = 'fit-content';
    root.querySelector('.fws-microsimu__first').style.padding = '0 7px';
    root.querySelector('.fws-microsimu__first').style.borderRadius = '30px';
  }
}
